<template>
  <div class="flex items-center gap-16">
    <RevIllustration
      alt=""
      class="h-auto w-[88px]"
      :height="88"
      :src="productImage"
      :width="88"
    />
    <div class="flex flex-col">
      <div class="body-1-bold">{{ productTitle }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { RevIllustration } from '@ds/components/Illustration'

defineProps<{
  averageRate?: number
  productTitle: string
  productImage: string
}>()
</script>
